import _toConsumableArray from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import TrackVisibility from 'react-on-screen';
import { ThemeProvider } from 'styled-components';
import { TEMPLATE_THEMES, MODULE_THEMES } from '../Theme';
import { Stack, Box } from '../ui';
import { Module } from '../Module';
import { useDynamicNavBarColor } from './useDynamicNavBarColor';
import { jsx as _jsx } from "react/jsx-runtime";

var carouselSlideIfPresent = function carouselSlideIfPresent(mod) {
  var _carouselSlides;

  return mod && 'carouselSlides' in mod ? (_carouselSlides = mod.carouselSlides) === null || _carouselSlides === void 0 ? void 0 : _carouselSlides[0] : mod;
};

export var LandingPageTemplate = function LandingPageTemplate(template) {
  var _template$theme = template.theme,
      theme = _template$theme === void 0 ? 'Dark' : _template$theme,
      heroModule = template.heroModule,
      _template$modules = template.modules,
      modules = _template$modules === void 0 ? [] : _template$modules;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeSlide = _React$useState2[0],
      setActiveSlide = _React$useState2[1];

  var tplTheme = TEMPLATE_THEMES[theme];

  var modTheme = function modTheme(mod) {
    return _objectSpread(_objectSpread({}, tplTheme), MODULE_THEMES[mod.themeName || ''] || {});
  };

  var isFullBleed = function isFullBleed(mod) {
    return ['relatedLinksModule', 'editorialGridModule', 'heroBodyModule', 'headerModule', 'heroBodyCarousel', 'heroHeaderCarousel', 'heroNarrativeCarousel', 'eventList', 'recirculationModule', 'videoModule'].includes(mod.contentType);
  };

  var allModules = [heroModule].concat(_toConsumableArray(modules || [])).filter(function (m) {
    return Boolean(m === null || m === void 0 ? void 0 : m.contentType);
  });
  useDynamicNavBarColor(activeSlide || carouselSlideIfPresent(allModules === null || allModules === void 0 ? void 0 : allModules[0]));
  var renderModule = React.useCallback(function (mod) {
    var isHeader = mod.id === (heroModule === null || heroModule === void 0 ? void 0 : heroModule.id);
    var isCarouselModule = ('carouselSlides' in mod);

    var modProps = _objectSpread({
      isHeader: isHeader,
      // for carousel headers, track slide change so we can grab current color for nav bar
      onShowSlide: isHeader && isCarouselModule ? setActiveSlide : undefined
    }, mod); // don't use the 'once' property here on TrackVisibility- we need our
    // own implementation of it, where we update the visibility but don't
    // fire the tracking event


    return /*#__PURE__*/_jsx(TrackVisibility, {
      offset: 'carouselSlides' in mod ? 200 : 50,
      children: function children(_ref) {
        var isVisible = _ref.isVisible;
        return /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Module, _objectSpread(_objectSpread({}, modProps), {}, {
            shouldAnimate: true,
            isVisible: isVisible
          }))
        });
      }
    });
  }, []);
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": "landing-".concat(template.urlSlug || 'unknown'),
    children: allModules.map(function (mod, idx) {
      return /*#__PURE__*/_jsx(ThemeProvider, {
        theme: modTheme(mod),
        children: /*#__PURE__*/_jsx(Box, {
          noPadding: isFullBleed(mod),
          transparent: idx === 0,
          children: renderModule(mod)
        })
      }, "".concat(mod.id, "-").concat(idx));
    })
  });
};